import Image from 'next/image';
import Link from 'next/link';

import { ArrowIcon } from '@endaoment-frontend/ui/icons';
import { Button } from '@endaoment-frontend/ui/shared';

import { SectionLabel } from '../sectionLabel';

import styles from './TwoScreensSection.module.scss';
import { TwoScreensButtonProps, TwoScreensSectionProps } from './TwoScreensSection.types';

const TwoScreensButton = ({ text, href, ...props }: TwoScreensButtonProps) => {
  return (
    <Link href={href} passHref>
      <Button as="a" target="_blank" rel="noreferrer" {...props}>
        {text}
        <ArrowIcon width={20} height={12} />
      </Button>
    </Link>
  );
};

export const TwoScreensSection = ({ title, image1Src, image2Src, subtext, children }: TwoScreensSectionProps) => {
  return (
    <section className={styles['two-screens-section']}>
      <SectionLabel text={title} />
      <div>
        <div className={styles['screenshot']}>
          <Image src={image1Src} alt="Product screenshot" priority layout="fill" placeholder="blur" />
        </div>
        <div className={styles['screenshot']}>
          <Image src={image2Src} alt="Product screenshot" priority layout="fill" placeholder="blur" />
        </div>
      </div>
      <p>{subtext}</p>
      {children}
    </section>
  );
};

TwoScreensSection.Button = TwoScreensButton;
